<template>
   
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input type="password" v-model="ruleForm.oldPassword"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" v-model="ruleForm.newPassword" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="再输一次新密码" prop="checkNewPassword">
          <el-input type="password" v-model="ruleForm.checkNewPassword" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item class="centerbtn tc">
            <el-button type="primary" @click="submitForm()">提交</el-button>
            <el-button @click="passwordDialogCancel()">取消</el-button>
        </el-form-item>
      </el-form>
   
</template>
<script>
import md5 from 'js-md5';
export default {
    data() {
      return {
        sysUserId: '',
        showModifyPassword: Boolean,
        rules: {
          oldPassword: [
            {
              required: true,
              message: "请输入原密码",
              trigger: "blur"
            }
          ],
          newPassword: [
              {
                required: true,
                message: "请输入新密码",
                trigger: "blur"
              },
              { min: 6, message: '长度不能少于6个字符,字母和数字组合' }
              
          ],
          checkNewPassword: [{validator:(rule,value,callback)=>{
                if(value == ""){
                    callback(new Error("请再输入一遍密码"));
                }else{
                    if(this.ruleForm.newPassword!=this.ruleForm.checkNewPassword){
                      callback(new Error("两次输入的新密码不一样"));
                    } else {
                       callback();
                    }
                }
            }, trigger:'blur'}]

        },
        ruleForm: {
            oldPassword:'',
            newPassword: '',
            checkNewPassword: ''
        }
        
      };
    },
    methods: {
      submitForm() {
              this.$refs.ruleForm.validate(valid => {
                if (valid) {
                  this.$axiosPackag.post('/api/manager/user/updatePassword', 
                      {"old_password": md5(this.ruleForm.oldPassword),"password":md5(this.ruleForm.newPassword),"userIds":this.sysUserId}, r => {
                          this.$message.success("修改成功！");
                          this.passwordDialogCancel();
                          this.clearForm();
                    });
                }
              }); 
      },
      // 取消
        passwordDialogCancel(){
                let  map ={};
                map['showModifyPassword']=false;
                this.$emit("listenChildEvent",map);
                this.clearForm();
            },
      //清空内容
        clearForm(){
            this.$refs.ruleForm.resetFields();
        },
       
    },
    mounted(){
       this.sysUserId = this.$sessionStore.getUserId();
    }
};
</script>
 



// WEBPACK FOOTER //
// ModifyPassword.vue?07bb5009